import { Flex, Icon, Text } from '@chakra-ui/react';
import { CompetitivenessLevel } from '@client/graphql/__generated__/types';
import { lowerCase, startCase } from 'lodash';
import { DotIcon } from 'lucide-react';
import { COMPETITION_COLORS } from './constants';

export const CompetitivenessLabel = ({
  level,
}: {
  level: CompetitivenessLevel;
}) => {
  return (
    <Flex alignItems="center" gap={1} pr={1}>
      <Icon as={DotIcon} color={COMPETITION_COLORS[level]} strokeWidth={8} />
      <Text flexShrink={0} fontWeight="medium">
        Market is {startCase(lowerCase(level))}
      </Text>
    </Flex>
  );
};
